import { Radio, RadioGroup, FormControlLabel, Typography } from "@mui/material";
import LoadingSkteleton from "../../../../../../load/loadingSkeleton";
import Delete from "../../../../../../utils/delete";
import { useState } from "react";


export default function AutorizacaoOptions({ options, value, onChange, empresa, tipoEstabelecimento }) {
    const [open, setOpen] = useState(false);
    // const optionText = AUTORIZACAO;

    return (
        <>
            <RadioGroup name="tipoAutorizacao" value={value} onChange={onChange}>
                {options.map((item, index) => (
                    <Typography key={item._id} m={2} style={{ position: 'relative' }}>

                        <Delete
                            button={true}
                            url='tipo-autorizacao/delete'
                            id={item._id}
                            open={open}
                            setOpen={setOpen}
                            msg={`Tem certeza que deseja eliminar esta opção`}
                            tipo={'Opção'}
                        />
                        <FormControlLabel
                            value={item.descricao}
                            control={<Radio />}
                            style={{ marginRight: 35 }}
                            label={
                                <>
                                    {index + 1} - Autoriza a empresa <b>{empresa}</b> a exercer a
                                    <b>{item.descricao}</b>,
                                </>
                            }
                        />
                    </Typography>
                ))}
            </RadioGroup>

            {options.length < 1 && <LoadingSkteleton />}
        </>
    );
}
